import { cn } from "./utils";

/** The pill every status is shown in: an icon, then the words (M31). */
export function pillClasses(large: boolean, tone: string): string {
  return cn(
    "inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border font-medium",
    large ? "px-3 py-1 text-sm" : "px-2 py-0.5 text-xs",
    tone,
  );
}

export function pillIconClasses(large: boolean): string {
  return large ? "size-4" : "size-3.5";
}
